import axios from 'axios';

export const httpClient = axios.create({
  // baseURL: 'http://68.178.174.119:5000',
  baseURL: "http://103.39.132.59"
  // baseURL: 'http://localhost:8881',

});